import { combineReducers } from "@reduxjs/toolkit";

// Slices
import LoginSlice from "../pages/login/Login.Slice";
import PgeActivitySlice from "../pages/pge_activity/PgeActivity.Slice";
import PgeSkillsetManagerSlice from "../pages/pge_skillset_manager/PgeSkillsetManager.Slice";
import UsersSlice from "../pages/users/Users.Slice";
import EceSkillsetManagerSlice from "../pages/ece_skillset_manager/EceSkillsetManager.Slice";
import VersionSlice from "../pages/version/Version.Slice";
import NsdcSlice from "../pages/nsdc/NsdcSlice";
import Manage_Nsdc_Slice from "../pages/manage_nsdc/Manage_Nsdc_Slice";
import EceActivitySlice from "../pages/ece_activity/EceActivity.Slice";
import TeacherCategorySlice from "../pages/teacherCategory/TeacherCategory.Slice";
import TeacherBaselineSlice from "../pages/teacherBaseline/TeacherBaseline.Slice";
import ExtraTopicSlice from "../pages/ExtraTopic/ExtraTopic.Slice";
import ExtraQuizSlice from "../pages/extra_quiz/ExtraQuiz.Slice";
import ExtraModuleSlice from "../pages/ExtraModule/ExtraModule.Slice";
import AudioAssessmentSlice from "../pages/AudioAssessment/AudioAssessment.Slice";
import PasscodeManagerSlice from "../pages/passcodemanager/PasscodeManager.Slice";
import BlockSlice from "../pages/BlocksDistricts/Blocks.Slice";
import CommonQuizTopicSlice from "../pages/CommonQuizTopic/CommonQuizTopic.Slice";
import CommonMonthlyQuizSlice from "../pages/CommonMonthlyQuiz/CommonMonthlyQuiz.Slice";
import FlnSkillSlice from "../pages/FlnSkill/FlnSkillSlice";
import FlnActivitySlice from "../pages/FlnActivity/FlnActivitySlice";
import StudentAssessmentSlice from "../pages/StudentAssessment/StudentAssessment.Slice";
import StudentAssessmentQuizSlice from "../pages/StudentAssessmentQuiz/StudentAssessmentQuiz.Slice";
import FlnTopicsSlice from "../pages/FlnTopics/FlnTopicsSlice";
import AmazonPaySlice from "../pages/AmazonPay/AmazonPaySlice";
import FaqSlice from "../pages/Faq/FaqSlice";
import FaqSectionSlice from "../pages/FaqSection/FaqSectionSlice";
import AudioLabelingSlice from "../pages/AudioLabeling/AudioLabelingSlice";
import threadsslice from "../pages/threads/threads-slice";
import templatesslice from "../pages/templates/templates-slice";
import AppSessionSlice from "../pages/App Session/AppSession.slice";
// import FlnActivitySlice from "../pages/FlnActivity/FlnActivitySlice";
// import ExtarAssignmentSlice from "../pages/ExtraAssignment/ExtraAssignment.Slice";

const MasterSlice = combineReducers({
  VersionSlice,
  LoginSlice,
  NsdcSlice,
  PgeActivitySlice,
  PgeSkillsetManagerSlice,
  Manage_Nsdc_Slice,
  EceSkillsetManagerSlice,
  EceActivitySlice,
  UsersSlice,
  templatesslice,
  TeacherCategorySlice,
  TeacherBaselineSlice,
  ExtraTopicSlice,
  ExtraQuizSlice,
  ExtraModuleSlice,
  AudioAssessmentSlice,
  StudentAssessmentSlice,
  StudentAssessmentQuizSlice,
  PasscodeManagerSlice,
  BlockSlice,
  CommonQuizTopicSlice,
  CommonMonthlyQuizSlice,
  FlnSkillSlice,
  FlnTopicsSlice,
  FlnActivitySlice,
  AmazonPaySlice,
  FaqSlice,
  FaqSectionSlice,
  AudioLabelingSlice,
  threadsslice,
  AppSessionSlice,
  // ExtarAssignmentSlice,
});
export default MasterSlice;
